<div
  class="color-circle"
  [colorPicker]="value"
  (colorPickerChange)="onColorPickerChange($event)"
  [style.background]="value"
  [cpOutputFormat]="'hex'"
  [cpAlphaChannel]="'always'"
  [class.selected]="selected"
  (cpToggleChange)="onToggleChanged($event)"
  [cpPosition]="'left'"
  [cpPositionRelativeToArrow]="true"
  [cpOKButton]="true"
  cpOKButtonClass="ok-btn"
  [cpOKButtonText]="'Apply'"
></div>
